import React from 'react';
import './full-screen-carousel-item.scss';
import { fireAnalytics } from '../../pages/utils';
import { connect } from 'react-redux';
import Download from '../../util/download';
import { DownloadEnum, MIN_FREE_STORAGE_MB } from '../../util/playerEnum';

const TAG = '[BD-Cache]';

class Artwork extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      artwork: props.artwork,
      showLoader: true,
      mute: props.setting.mute,
      highquality: props.setting.highResolution,
      isCurrent: props.isCurrent,
      downloadInfo: false,
      posterImage: true,
      downloadingCurrent: false,
      nextArtwork: null,
      lastMobileUpdate: props.lastMobileUpdate,
      percentage: 0,
      currentDownloads: props.currentDownloads,
      artworks: props.artworks,
      skipcount: 0,
      navigation: props.navigation,
      matchContent: props.setting.matchContent,
      artworkError: false,
      artworkErrorMessage: '',
      skippedUrls: [],
      unpaired: props.unpaired,
      iframe: false,
    };
    this.previousArtworks = null;
    this.download = new Download(this.state.artwork);
    this.getArtworkUrl = this.getArtworkUrl.bind(this);
    this.getArtworkVideoUrl = this.getArtworkVideoUrl.bind(this);
    this.handleConnectionChangePlayer = this.handleConnectionChangePlayer.bind(this);
    this.downloadInfoText = '';
    this.download;
    this.prevURL;
    this.playbackPath = 'http://127.0.0.1:9080/Blackdove/';
    this.videoPlaybackStarted = false;
    this.downloadFileTimeout;
    this.playlistArtworksLength = this.state.artworks.length;
    this.downloadIndex = 0;
    this.cachedIds = new Set();
    this.storageFull = false;
    this.floorEnforced = false;
    this.errorMsgTimeout = null;
    this.iframeTimeout = null;
    this.posterRef = React.createRef();
    this.videoRef = React.createRef();
    this.iframeRef = React.createRef();
    // this.sampleOfflineList = [{ name: "9e609526-d57a-440b-b63a-4eaaf02bec05.mp4" }, { name: "10f49020-751e-42a6-b1a6-b67be98d1347.mp4" },
    // { name: "fb5eac54-0493-42a0-806e-c0c0c9d70d2e.mp4" }, { name: "b5fda997-235f-4e1b-b980-126d2c34b590.mp4" }, { name: "c5d8c1be-0a36-4a23-a655-3639f43c4390.mp4" }, { name: "c1d9949e-7346-4540-9df4-cf0d870779e8.mp4" }, { name: "cd96788c-480a-49e9-acc3-08d5591f594d.mp4" },]
    // this.testObj = this.artworks.filter(o1 => this.sampleOfflineList.some(o2 => o1.id === o2.name.toString().split(".mp4")[0]));
    // console.log("this.testObj", this.testObj);
    // clearTimeout(this.timeouttest);
    // this.timeouttest = setTimeout(() => {
    //   this.props.playOfflineArtworks(this.testObj);
    // }, 10000);
    screen.orientation.addEventListener('change', (event) => {
      const type = event.target.type;
      console.log(`ScreenOrientation change: ${type}`);
      this.applyRotation(this.props.artwork, type);
    });
    this.updateDownloadPercentage();
    console.log('New Variables : ', this.playlistArtworksLength, this.downloadIndex);
  }

  updateDownloadPercentage = () => {
    const that = this;
    setInterval(() => {
      this.setState({ percentage: (that.download && that.download.percentage) || 0 });
      this.setState({ downloadingCurrent: that.download && that.download.downloadingCurrent });
    }, 1000);
  };

  handleConnectionChangePlayer(event) {
    if (event.type == 'offline') {
      this.showPopup("Player went Offline");
      console.log('offline on carousel item');
      const offlineArtworksList = this.download.offlineFilesList;
      console.log('offline files list : ', offlineArtworksList);  
      this.props.playDownloadedArtworkOnly(offlineArtworksList);
    }
    if (event.type == 'online') {
      console.log('online on carousel item');
    }
  }

  fileCheckCallback = (key, data) => {
    const that = this;
    switch (key) {
      case DownloadEnum.FILE_EXISTS:
        console.log(TAG, `Cached: ${data.fileName}`);
        this.cachedIds.add(data.fileName);
        this.props.handleUpdateDownloads(data.fileName);
        if (data.fileName === this.getFileName()) {
          this.startPlayback(data.fileName);
        }
        this.advanceDownloadIndex();
        break;
      case DownloadEnum.FILE_NOT_IN_LOCAL:
        if (this.storageFull) {
          console.log(TAG, `Storage full - skipping ${data.fileName}`);
          this.advanceDownloadIndex();
          return;
        }
        console.log(TAG, `Not cached: ${data.fileName} - checking space`);
        if(data.fileName !== undefined){
          this.download.checkSpace((key) => {
            that.spaceCheckCallback(key);
          });
        }
        break;
      default:
        break;
    }
  };

  downloadCallback = (key, data) => {
    switch (key) {
      case DownloadEnum.DOWNLOAD_COMPLETE:
        console.log(TAG, `Download complete: ${data.fileName}`);
        this.cachedIds.add(data.fileName);
        this.props.handleUpdateDownloads(data.fileName);
        if (data.fileName === this.getFileName()) {
          this.startPlayback(data.fileName);
        }
        this.advanceDownloadIndex();
        break;
      case DownloadEnum.DOWNLOAD_ERROR:
        console.log(TAG, `Download error: ${data.fileName}`, data);
        this.advanceDownloadIndex();
        break;
      default:
        break;
    }
  };

  getFileName = () => {
    return this.state.artwork.id;
    // let url = this.state.artwork.media.video.full['4k'].mp4;
    // return url.toString().split('/')[url.toString().split('/').indexOf('mp4') + 1]
  };

  checkFileHeadLengthCallback = (key, url) => {
    const that = this;
    switch (key) {
      case DownloadEnum.CONTINUE_DOWNLOAD:
        console.log(TAG, `Starting download: ${this.download.fileName}`);
        this.download.startDownload((key, data) => {
          that.download.cancelDownloadInterval();
          that.downloadCallback(key, data);
        }, this.state.highquality);
        break;
      case DownloadEnum.GOTO_NEXT_ARTWORK: {
        console.log(TAG, `File too large for remaining space: ${this.download.fileName} - attempting eviction`);
        const floorBytes = MIN_FREE_STORAGE_MB * 1024 * 1024;
        this.download.evictForSpace((evictResult) => {
          if (evictResult === DownloadEnum.SPACE_FREED) {
            console.log(TAG, 'Eviction freed space, retrying file size check');
            that.download.checkFileHeadLength((headKey, data) => {
              that.checkFileHeadLengthCallback(headKey, data);
            }, that.state.highquality);
          } else {
            // Don't mark storage full - a smaller file later may still fit.
            // Just skip this file and try the next artwork in the queue.
            console.log(TAG, `Skipping ${that.download.fileName} - too large, no eviction candidates`);
            that.advanceDownloadIndex();
          }
        }, floorBytes);
        break;
      }
      case DownloadEnum.SHOW_STILL_IMAGE: {
        const poster = this.posterRef.current;
        if (poster) poster.src = url;
        this.applyRotation(this.props.artwork, screen.orientation.type);
        this.advanceDownloadIndex();
        break;
      }
      default:
        break;
    }
  };

  spaceCheckCallback = (key) => {
    const that = this;
    switch (key) {
      case DownloadEnum.SPACE_AVAILABLE:
        console.log(TAG, 'Space available, checking file size');
        this.download.checkFileHeadLength((key, data) => {
          that.checkFileHeadLengthCallback(key, data);
        }, this.state.highquality);
        break;
      case DownloadEnum.SPACE_NOT_AVAILABLE: {
        console.log(TAG, 'Space below floor, attempting eviction of stale files');
        const floorBytes = MIN_FREE_STORAGE_MB * 1024 * 1024;
        this.download.evictForSpace((evictResult) => {
          if (evictResult === DownloadEnum.SPACE_FREED) {
            console.log(TAG, 'Eviction freed space, checking file size');
            that.download.checkFileHeadLength((headKey, data) => {
              that.checkFileHeadLengthCallback(headKey, data);
            }, that.state.highquality);
          } else {
            console.log(TAG, 'Cannot free space - storage full, truncating playlist');
            that.markStorageFull();
          }
        }, floorBytes);
        break;
      }
      default:
        break;
    }
  };

  cancelDownloadCallback = (key) => {
    const that = this;
    console.log('cancelDownloadCallback function', key);
    that.download.cancelDownloadInterval();
    switch (key) {
      case DownloadEnum.DOWNLOAD_CANCELED:
        this.download.checkFileExists((key, data) => {
          console.log('File Check Callback', key, data);
          that.fileCheckCallback(key, data);
        });
        break;
      case DownloadEnum.DOWNLOAD_CANCELED_ERROR:
        console.log('Cannot Cancel Download');
        break;
      default:
        console.log('DEFAULT case cancelDownloadCallback::: Do Nothing');
        break;
    }
  };

  advanceDownloadIndex = () => {
    this.downloadIndex = this.downloadIndex + 1;

    const { artworks } = this.state;

    if (this.downloadIndex < artworks.length && artworks[this.downloadIndex] !== undefined) {
      const next = artworks[this.downloadIndex];
      console.log(TAG, `Queue: checking artwork ${this.downloadIndex + 1}/${artworks.length} (${next.id})`);
      this.download.updateConfig(next);
      this.downloadFileTimeout = setTimeout(() => {
        this.download.checkFileExists((key, data) => {
          this.fileCheckCallback(key, data);
        });
      }, 1500);
    } else {
      // Full scan complete
      this.logPlaylistSummary(this.storageFull);
      if (this.storageFull) {
        const cachedArtworks = artworks.filter((a) => this.cachedIds.has(a.id));
        if (this.props.playDownloadedArtworkOnly) {
          this.props.playDownloadedArtworkOnly(cachedArtworks);
        }
      }
    }
  };

  markStorageFull = () => {
    this.storageFull = true;
    // Don't truncate yet - let the scan finish to find all cached files
    this.advanceDownloadIndex();
  };

  logPlaylistSummary = (truncated) => {
    const { artworks } = this.state;
    const cached = artworks.filter((a) => this.cachedIds.has(a.id));
    const missing = artworks.filter((a) => !this.cachedIds.has(a.id));
    const storageType = this.download.isUSB ? 'USB' : 'INTERNAL';
    const availMB = (this.download.availableStorage / (1024 * 1024)).toFixed(1);

    console.log(TAG, '=== Playlist Summary ===');
    console.log(TAG, `Storage: ${storageType} | Path: ${this.download.staticInternalPath}`);
    console.log(TAG, `Free: ${availMB} MB | Floor: ${MIN_FREE_STORAGE_MB} MB`);
    console.log(TAG, `Playlist: ${artworks.length} artworks`);
    console.log(TAG, `Cached: ${cached.length} | Not cached: ${missing.length}`);
    if (truncated) {
      console.log(TAG, `TRUNCATED: playing ${cached.length} of ${artworks.length}`);
    }
    cached.forEach((a) => console.log(TAG, `  [cached]   ${a.id} (${a.name || 'untitled'})`));
    missing.forEach((a) => console.log(TAG, `  [missing]  ${a.id} (${a.name || 'untitled'})`));
    console.log(TAG, '========================');
  };

  startPlayback = (fileName) => {
    if (this.download.isUSB) {
      this.playbackPath = `http://127.0.0.1:9080/external/${window.usbName}/list/me/`;
    }
    const offlineURL = this.playbackPath + fileName + '.mp4';
    console.log(TAG, `Playback: ${offlineURL}`);
    const video = this.videoRef.current;
    if (video) {
      video.pause();
      video.src = offlineURL;
      video.load();
      video.play();
    }
  };

  applyRotation(artwork, type) {
    if (!artwork.sourceFile) return;

    const video = this.videoRef.current;
    const poster = this.posterRef.current;
    const iframe = this.iframeRef.current;
    const { fillScreen } = this.props.setting;

    const artWidth = parseInt(artwork.sourceFile.metadata.width) || 1080;
    const artHeight = parseInt(artwork.sourceFile.metadata.height) || 1920;

    console.log('Current screen orientation', type);
    console.log('Current artwork width', artWidth, '& height', artHeight);

    const applyToElements = (elements, styles, classesToAdd = [], classesToRemove = []) => {
      elements.forEach(element => {
        if (!element) return;

        // Apply styles
        Object.entries(styles).forEach(([property, value]) => {
          element.style[property] = value;
        });

        // Remove classes
        classesToRemove.forEach(className => {
          element.classList.remove(className);
        });

        // Add classes
        classesToAdd.forEach(className => {
          element.classList.add(className);
        });
      });
    };

    const rotationClasses = ['posterRotated', 'posterRotatedPortrait', 'posterRotatedUnpaired'];

    // contain = default (fit inside, preserve aspect ratio, letterbox/pillarbox)
    // cover = fillScreen ON (fill container, preserve aspect ratio, crop overflow)
    const objectFit = fillScreen ? 'cover' : 'contain';

    [video, poster, iframe].forEach(element => {
      if (!element) return;
      rotationClasses.forEach(cls => element.classList.remove(cls));
      element.style['object-fit'] = objectFit;
    });
  }

  matchArttoScreen(callback, artwork) {
    if (!artwork?.sourceFile?.metadata) {
      return;
    }

    const { matchContent } = this.props.setting;
    const { width, height } = artwork.sourceFile.metadata;
    const artWidth = parseInt(width);
    const artHeight = parseInt(height);
    const isPortrait = screen.orientation.type !== 'landscape-primary';

    console.log('Current screen orientation:', screen.orientation.type);
    console.log('Current artwork video width:', artWidth, '& height:', artHeight);
    console.log(TAG, `Match content orientation: ${matchContent ? 'ON' : 'OFF'}`);

    const isArtworkLandscape = artWidth > artHeight;
    const isOrientationMismatch = isPortrait ? isArtworkLandscape : !isArtworkLandscape;

    if (!matchContent || !isOrientationMismatch) {
      this.continueWithArtwork(artwork, callback);
      return;
    }

    this.handleOrientationMismatch(callback);
  }

  continueWithArtwork(artwork, callback) {
    this.resetArtworkError();
    this.download.updateConfig(artwork);
    this.setState({ artwork });
    callback("CONTINUE_DOWNLOAD");
  }

  handleOrientationMismatch(callback) {
    console.log(TAG, 'Artwork orientation does not match screen - skipping');
    setTimeout(() => {
      callback("NEXT_ARTWORK");
    }, 100);
  }

  resetArtworkError() {
    if (this.state.artworkError) {
      this.setState({ artworkError: false });
    }
  }

  filterByOrientation = (artworks) => {
    const { matchContent } = this.props.setting;
    if (!matchContent) return artworks;

    const isPortrait = screen.orientation.type !== 'landscape-primary';
    const filtered = artworks.filter((a) => {
      if (!a.sourceFile?.metadata) return true;
      const w = parseInt(a.sourceFile.metadata.width) || 0;
      const h = parseInt(a.sourceFile.metadata.height) || 0;
      if (w === 0 && h === 0) return true;
      const isArtworkLandscape = w > h;
      const isMismatch = isPortrait ? isArtworkLandscape : !isArtworkLandscape;
      return !isMismatch;
    });

    if (filtered.length < artworks.length) {
      console.log(TAG, `matchContent filtered: ${artworks.length} -> ${filtered.length} (removed ${artworks.length - filtered.length} mismatched)`);
    }

    return filtered.length > 0 ? filtered : artworks;
  };

  logCollectionContents = (artworks, reason) => {
    const isPortrait = screen.orientation.type !== 'landscape-primary';
    const screenOrientation = isPortrait ? 'PORTRAIT' : 'LANDSCAPE';
    console.log(TAG, `=== Collection Loaded (${reason}) ===`);
    console.log(TAG, `Screen: ${screenOrientation} | Items: ${artworks.length}`);
    artworks.forEach((a, i) => {
      const w = parseInt(a.sourceFile?.metadata?.width) || 0;
      const h = parseInt(a.sourceFile?.metadata?.height) || 0;
      const orientation = w > h ? 'landscape' : w < h ? 'portrait' : 'square';
      console.log(TAG, `  ${i + 1}. ${a.name || 'untitled'} (${a.id}) - ${orientation} (${w}x${h})`);
    });
    console.log(TAG, '===================================');
  };

  componentDidMount() {
    const s = this.props.setting;
    console.log(TAG, '=== Player Settings ===');
    console.log(TAG, `  matchContent: ${s.matchContent}`);
    console.log(TAG, `  fillScreen:   ${s.fillScreen}`);
    console.log(TAG, `  mute:         ${s.mute}`);
    console.log(TAG, `  highRes:      ${s.highResolution}`);
    console.log(TAG, `  showLogo:     ${s.showLogo}`);
    console.log(TAG, `  showDetails:  ${s.showArtworkDetails}`);
    console.log(TAG, `  qr:           ${s.qr}`);
    console.log(TAG, `  randomise:    ${s.randomise}`);
    console.log(TAG, '=======================');

    // Log poster and video URLs for current artwork
    const artwork = this.state.artwork;
    const posterUrl = artwork?.media?.image?.high?.landscape || artwork?.media?.image?.ultra?.landscape || 'N/A';
    const videoUrlHigh = artwork?.media?.video?.full?.high?.mp4 || 'N/A';
    const videoUrl4k = artwork?.media?.video?.full?.['4k']?.mp4 || 'N/A';
    console.log(TAG, `=== Media URLs for: ${artwork?.name} ===`);
    console.log(TAG, `  Poster:    ${posterUrl}`);
    console.log(TAG, `  Video FHD: ${videoUrlHigh}`);
    console.log(TAG, `  Video UHD: ${videoUrl4k}`);

    // Filter out orientation-mismatched artworks when matchContent is on
    const filteredArtworks = this.filterByOrientation(this.state.artworks);
    if (filteredArtworks !== this.state.artworks) {
      this.setState({ artworks: filteredArtworks });
    }

    this.logCollectionContents(filteredArtworks, 'initial load');

    // Tell the download manager which IDs belong to the current playlist
    const playlistIds = (filteredArtworks || []).map((a) => a.id).filter(Boolean);
    this.download.setProtectedIds(playlistIds);

    // List cached files, then enforce the 200 MB floor before any downloads
    this.download.listDownloadFiles(() => {
      this.download.enforceFloor(() => {
        // Floor enforced - now safe to begin download flow
        this.floorEnforced = true;
        if (this.props.isCurrent) {
          this.getArtworkVideoUrl(this.props.artwork);
        }
      });
    });
    const video = this.videoRef.current;
    this.applyRotation(this.props.artwork, screen.orientation.type);
    this.interval = setInterval(() => {
      if (this.state.mute != this.props.setting.mute && this.props.isCurrent) {
        this.setState({
          mute: this.props.setting.mute,
        });
      }
    }, 4000);

    video.onplaying = () => {
      this.videoPlaybackStarted = true;
      console.log(TAG, `Video playing: ${video.videoWidth}x${video.videoHeight} | Element: ${video.clientWidth}x${video.clientHeight} | Screen: ${window.innerWidth}x${window.innerHeight}`);
      setTimeout(() => {
        this.setState({ posterImage: false });
      }, 1000);
    };

    window.addEventListener('online', this.handleConnectionChangePlayer);
    window.addEventListener('offline', this.handleConnectionChangePlayer);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    clearTimeout(this.downloadFileTimeout);
    this.download.cancelDownloadInterval();
  }

  getArtworkUrl(artwork) {
    if (
      artwork &&
      artwork.media &&
      artwork.media.image &&
      artwork.media.image.ultra &&
      artwork.media.image.ultra.landscape
    ) {
      return artwork.media.image.high.landscape || artwork.media.image.ultra.landscape;
    }
    return '';
  }

  getIframeLink(imgUrl) {
    const that = this;

    const urlArr = imgUrl.split('.');
    const urlExtension = urlArr[urlArr.length - 1];
    const extArr = urlExtension.split('/');
    const artExtension = extArr[0];

    const { externalContentUrl } = that.state.artwork;

    const iframe = this.iframeRef.current;

    if(externalContentUrl !== null || artExtension === 'html' || artExtension === 'io'){
      iframe.src = externalContentUrl || imgUrl;
      this.setState({ posterImage: false });
      this.setState({ iframe: true });
    }
  }

  handleDownloadActions(key, url){
    const that = this;
    switch (key) {
      case "CONTINUE_DOWNLOAD":
        if (this.download && this.download.isDownloadProgress) {
          console.log("cancelled download on new download")
          that.download.cancelDownload((key) => {
            console.log('Cancel Download Callback', key);
            that.cancelDownloadCallback(key);
          });
        } else {
          this.downloadFileTimeout = setTimeout(() => {
            this.download.checkFileExists((key, data) => {
              console.log('File Check Callback', key, data);
              that.fileCheckCallback(key, data);
            });
          }, 1500);
        }
        fireAnalytics('PlayVideo', 'Play', url);
        break; 
      case "NEXT_ARTWORK":
        if (this.state.skipcount >= this.state.artworks.length){
          clearTimeout(this.errorMsgTimeout);
          this.showPopup("No artworks match the current screen orientation");
          this.props.showPermanentPopup();
        }else{
          if(!this.state.skippedUrls.includes(url)){
            this.state.skippedUrls.push(url);
            this.setState(prevState => ({
              skipcount: prevState.skipcount + 1
            }));
          }
          console.log("skipped count",this.state.skipcount,"out of",this.state.artworks.length)
          const newArray = this.state.artworks.slice(0);
          newArray.push(newArray.shift());
          this.setState({artworks: newArray});
          const artwork = newArray[0];
          const nextUrl = artwork.media?.video?.full.high.mp4;
          that.matchArttoScreen((key) => {
            this.handleDownloadActions(key, nextUrl);
          },artwork); 
        }
        break;
    }
  }

  getArtworkVideoUrl(artwork) {
    const { isCurrent } = this.props;
    const that = this;
    if (isCurrent && !this.floorEnforced) {
      console.log(TAG, 'Floor not yet enforced - deferring download');
      return '';
    }
    if (isCurrent) {
      if (artwork?.contentType !== 'VIDEO') {
        this.props.navigate('next');
        return;
      }
      let url = artwork.media?.video?.full.high.mp4;
      
      if (this.prevURL !== url && isCurrent) {
        this.prevURL = url;
        clearTimeout(this.downloadFileTimeout);
        that.matchArttoScreen((key) => {
          this.handleDownloadActions(key, url);
        },artwork); 
      }
      return '';
    }
    return '';
  }

  checkArtworksInLocalStorage(){
    console.log("Check artworks in storage");
    const artworks = this.state.artworks;
    for(let i in artworks){
      this.download.checkFileExists((key,data)=>{
        if(key === "FILE_EXISTS"){
          this.props.handleUpdateDownloads(data.fileName);
        }
      }, artworks[i]);
    }
  }

  showPopup(msg) {
    clearTimeout(this.errorMsgTimeout);
    if(!this.state.artworkError){
      this.setState({ artworkErrorMessage : msg});
      this.setState({ artworkError: true });
      this.errorMsgTimeout = setTimeout(() => {
        this.setState({ artworkError: false });
      }, 2000);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.artwork !== this.props.artwork) {
      this.setState({ iframe: false });
      clearTimeout(this.iframeTimeout);
      this.iframeTimeout = setTimeout(() => {
        this.getIframeLink(this.props.artwork?.media?.image?.high.landscape);
      }, 3000);
      this.getArtworkVideoUrl(this.props.artwork);
    }
  }

  componentWillReceiveProps({ artwork, lastMobileUpdate, artworks, navigation, matchContent, closedSettings }) {
    const stateUpdates = {};
    
    // Handle mobile update changes
    this.handleMobileUpdateChange(lastMobileUpdate);
    
    // Log when a new playlist/collection is received
    if (artworks !== this.props.artworks && artworks?.length) {
      this.logCollectionContents(artworks, 'playlist update');
    }

    // Handle artwork changes - compare old props to new props, not state.
    // State may differ from props when orientation matching selects a different artwork.
    if (artwork.id !== this.props.artwork.id) {
      this.handleArtworkChange(artwork, artworks, stateUpdates);
    }

    // Handle playlist update status
    if (this.props.isPlaylistUpdated) {
      this.props.changeUpdatePlaylistStatus();
    }

    // Handle skip count reset conditions
    if (navigation || matchContent === false || closedSettings === true) {
      stateUpdates.skipcount = 0;
      stateUpdates.skippedUrls = [];
    }

    // Apply all state updates at once
    if (Object.keys(stateUpdates).length > 0) {
      this.setState(stateUpdates);
    }
  }

  // Helper method for mobile update handling
  handleMobileUpdateChange(lastMobileUpdate) {
    if (this.state.lastMobileUpdate === null) {
      this.setState({ lastMobileUpdate });
      return;
    }

    if (lastMobileUpdate === this.state.lastMobileUpdate) {
      return;
    }

    console.log("cancelled download on mobile update");

    this.download.cancelDownload(key => {
      console.log('Cancel Download on Playlist Change', key);
    });

    // Don't wipe the cache — existing files that are still in the new playlist
    // remain valid. Stale files (not in protectedIds) will be evicted naturally
    // when space is needed by evictForSpace().

    // Reset download counter (scan will rebuild it for new playlist)
    this.props.handleUpdateDownloads(0);

    // Reset eviction state and download queue for new playlist
    this.storageFull = false;
    this.cachedIds = new Set();
    clearTimeout(this.downloadFileTimeout);
    this.downloadIndex = 0;

    this.setState({
      skipcount: 0,
      skippedUrls: [],
      lastMobileUpdate
    });
  }

  // Helper method for artwork change handling
  handleArtworkChange(artwork, artworks, stateUpdates) {
    console.log('Artwork changed previous', artwork, 'And current', this.state.artwork);

    // Handle video cleanup
    const video = this.videoRef.current;
    video.pause();
    video.src = '';
    this.videoPlaybackStarted = false;

    // Cancel ongoing downloads and reset queue for new artwork/playlist
    clearTimeout(this.downloadFileTimeout);
    this.downloadIndex = 0;
    if (this.download?.isDownloadProgress) {
      this.download.cancelDownload(key => {
        console.log('Cancel Download on Artwork Change', key);
      });
    }

    // Filter out orientation-mismatched artworks when matchContent is on
    const filteredArtworks = this.filterByOrientation(artworks);

    // Update download configuration and protected IDs for new playlist
    console.log("updated config when received props");
    this.download.updateConfig(artwork);
    const playlistIds = (filteredArtworks || []).map((a) => a.id).filter(Boolean);
    this.download.setProtectedIds(playlistIds);
    this.download.listDownloadFiles();

    // Apply rotation
    this.applyRotation(artwork, screen.orientation.type);

    // Batch state updates
    Object.assign(stateUpdates, {
      showLoader: true,
      artwork,
      artworks: filteredArtworks,
      posterImage: true,
    });
  }

  render() {
    const { artwork } = this.state;
    return (
      <div className="full-screen-carousel-item">
        <div
          className="full-screen-carousel-item__image"
          style={
            !this.props.isCurrent && !this.props.nxtPre
              ? { backgroundImage: `url(${this.getArtworkUrl(artwork)})` }
              : { background: `none` }
          }
        >
          <img
            className="poster"
            id="poster"
            ref={this.posterRef}
            src={this.getArtworkUrl(artwork)}
            style={this.state.posterImage ? { opacity: '1' } : { opacity: '0' }}
          />
          {this.state.showLoader ? (
            <div className="Loader">
              <svg className="progress" width="100" height="100">
                <circle
                  cx="50"
                  cy="50"
                  stroke="#ffffff"
                  r="30"
                  fill="transparent"
                  strokeWidth="10"
                  strokeDasharray="189"
                  strokeDashoffset={188 - (this.state.percentage / 100) * 188}
                />
                <text
                  className="loading"
                  fill="#ffffff"
                  x="50"
                  y="50"
                  alignmentBaseline="middle"
                  textAnchor="middle"
                ></text>
              </svg>
              {this.state.downloadingCurrent ? (
                <span 
                  className="loading"
                  style={{ 
                    "margin-left": window.innerWidth < window.innerHeight ? "2vh" : "3.5vh" 
                  }}
                  >{`${this.state.percentage} %`}</span>
                // <div className="downloadPercentage">{`${this.state.percentage} %`}</div>
              ) : null}
            </div>
          ) : null}
          {this.props.isCurrent ? (
            <video
              tabIndex="-1"
              id="video"
              muted={this.state.mute ? true : false}
              loop
              autoPlay
              ref={this.videoRef}
              onPlay={() => {
                this.setState({ showLoader: false });
              }}
              style={{ height: '100%', width: '100%' }}
            ></video>
          ) : null}
          <iframe 
            className="poster"
            id="iframe"
            ref={this.iframeRef}
            style={this.state.iframe ? { opacity: '1' } : { opacity: '0' }}
          />
          {/* {(this.props.nxtPre || this.props.other) ? <video tabIndex="-1" src={this.getArtworkVideoUrl(artwork)} muted onCanPlay={() => { this.props.loadOthers() }} poster={this.getArtworkUrl(artwork)}></video> : null} */}
        </div>
        <div className="artworkError" style={!this.state.artworkError ? { opacity: '0' } : { opacity: '1' }}>
          {this.state.artworkErrorMessage}
        </div>
      </div>
    );
  }
}

export default connect((state) => {
  const { setting } = state;
  return {
    setting,
  };
}, null)(Artwork);
